import {Tooltip} from "@/components/toolTip/Tooltip.tsx";
import {PrivateLocationStatus, PrivateLocationStatusCode} from "@/lib/types/monitoring.ts";

export interface LoadAverageCellProps {
  status: PrivateLocationStatus;
}

const getLoadCssClass = (status?: PrivateLocationStatus) => {
  if (!status?.details?.check_load) {
    return "text-muted";
  }
  if (status.details.check_load.status === PrivateLocationStatusCode.ERROR) {
    return "pulse-color-red-600";
  } else {
    return "pulse-color-green-600";
  }
};

export const LoadAverageCell = ({status}: LoadAverageCellProps) => {
  if (!status?.details?.check_load) {
    return "unknown";
  }

  const loadAvgMatch = status.details.check_load.description.match(/load average: ([\d., ]+)\|/i);

  if (!loadAvgMatch) {
    return "unknown ";
  }

  const [min1, min5, min15] = loadAvgMatch[1].split(", ");

  return (
    <Tooltip
      delayMs={300}
      tooltipContent={
        <div>
          <div className={"d-flex justify-content-between"}>
            <span className={"pe-1"}>1 minute:</span> <span>{min1}%</span>
          </div>
          <div className={"d-flex justify-content-between"}>
            <span className={"pe-1"}>5 minute:</span> <span>{min5}%</span>
          </div>
          <div className={"d-flex justify-content-between"}>
            <span className={"pe-1"}>15 minute:</span> <span>{min15}%</span>
          </div>
        </div>
      }
    >
      <span className={getLoadCssClass(status)}>{loadAvgMatch[1]}</span>
    </Tooltip>
  );
};
